module.exports = __webpack_public_path__ + "img/icon_email.6d90e1c5.svg";